import { useCallback, useMemo } from 'react';

import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';
import { SortDirectionEnum } from '@/models/gen/graphql';
import { useLostAndFoundHistory } from '@/features/LostAndFoundHistory';

const LostAndFoundHistoryTableColumns = (): JSX.Element => {
  return (
    <SimpleTableRow header>
      <SelectAllCell />
      <SortableCell name="TRIP_AIRPORT_CODE">Airport</SortableCell>
      <SortableCell name="CREATED_AT">Created</SortableCell>
      <SortableCell name="DISPATCHER_NAME">Dispatcher</SortableCell>
      <SortableCell name="TRIP_SERVICER_IATA_AIRLINE_CODE">AL</SortableCell>
      <SortableCell name="TRIP_FLIGHT_NAME">FLT #</SortableCell>
      <SortableCell name="VEHICLE_TRACKING_ID">Van</SortableCell>
      <SortableCell name="DRIVER_NAME">Driver</SortableCell>
      <SortableCell name="DESCRIPTION">Description</SortableCell>
      <SortableCell name="RETURN_STATUS">Item Status</SortableCell>
    </SimpleTableRow>
  );
};

const SelectAllCell = (): JSX.Element => {
  const [{ reports, selected }, setState] = useLostAndFoundHistory(({ reports, selected }) => ({ reports, selected }));

  const isSelectAll = useMemo((): boolean => {
    if (selected.size !== reports.size) return false;
    for (const id of selected.keys()) {
      if (!reports.has(id)) return false;
    }
    return true;
  }, [reports, selected]);

  const onClick = useCallback(
    (): void => setState((current) => ({ ...current, selected: isSelectAll ? new Map() : reports })),
    [reports, isSelectAll, setState]
  );

  return <SimpleTableCell.Select checked={isSelectAll} onChange={onClick} />;
};
const SortableCell = ({ name, children }: { name: string; children: React.ReactNode }): JSX.Element => {
  const [{ sortBy, sortDirection }, setState] = useLostAndFoundHistory(({ sortBy, sortDirection }) => ({ sortBy, sortDirection }));
  const onSort = (name: string, direction: SortDirectionEnum): void =>
    setState((current) => ({ ...current, sortBy: name, sortDirection: direction }));
  return (
    <SimpleTableCell.Sortable name={name} sortBy={sortBy} sortDirection={sortDirection} onSort={onSort}>
      {children}
    </SimpleTableCell.Sortable>
  );
};

export default LostAndFoundHistoryTableColumns;
